import React from "react";
import { DATE_FORMAT, DEFAULT_DATE, DEFAULT_DATE_VIEWS } from "consts";
//
import { KeyboardDatePicker } from "@material-ui/pickers";
import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
    root: {
        display: "block",
    },
    input: {
        fontSize: "14px",
        width: "100%",
    },
});

const DatePicker = (props) => {
    const { classes, disabled, minDate, value, format, views, label, error, onChange } = props;
    const defaultMinDate = new Date(DEFAULT_DATE);

    return (
        <KeyboardDatePicker
            className={classes.root}
            disabled={disabled}
            autoOk
            variant="inline"
            inputVariant="filled"
            minDate={minDate || defaultMinDate}
            minDateMessage={null}
            value={value}
            onChange={(date) => onChange(date)}
            onClear={() => onChange(null)}
            format={format || DATE_FORMAT}
            views={views || DEFAULT_DATE_VIEWS}
            invalidDateMessage={null}
            label={label}
            InputProps={{
                className: classes.input,
            }}
            PopoverProps={{
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center",
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center",
                },
            }}
            error={error}
        />
    );
}

export default withStyles(styles, { withTheme: true })(DatePicker);
